var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: "修改关于" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.language,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "language", $$v)
                        },
                        expression: "form.language"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" }
                      }),
                      _c("el-option", { attrs: { label: "英语", value: "en" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "新闻内容", prop: "desc" }
                },
                [
                  _c("Editor", {
                    model: {
                      value: _vm.form.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desc", $$v)
                      },
                      expression: "form.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }